import { z } from 'zod';

export const pricingTypeItemSchema = z.object({
  id: z.uuid(),
  title: z.string(),
  type: z.string(),
});

export type PricingTypeItem = z.infer<typeof pricingTypeItemSchema>;

export const createPricingTypeInput = z.object({
  title: z.string().min(1),
  type: z.string().min(1),
});

export type CreatePricingTypeInput = z.infer<typeof createPricingTypeInput>;

export const updatePricingTypeInput = z
  .object({
    id: z.uuid(),
    title: z.string().min(1).optional(),
    type: z.string().min(1).optional(),
  })
  .refine((v) => v.title !== undefined || v.type !== undefined, {
    message: 'At least one of title or type must be provided',
  });

export type UpdatePricingTypeInput = z.infer<typeof updatePricingTypeInput>;

export const findPricingTypesInput = z.object({
  offset: z.number().int().min(0).optional(),
  limit: z.number().int().min(1).max(200).optional(),
  sort: z.enum(['title', 'type', 'createdOn']).optional(),
  order: z.enum(['asc', 'desc']).optional(),
});

export type FindPricingTypesInput = z.infer<typeof findPricingTypesInput>;

export const findPricingTypesResultSchema = z.object({
  data: z.array(pricingTypeItemSchema),
  count: z.number().int().nonnegative(),
  countAll: z.number().int().nonnegative(),
});

export type FindPricingTypesResult = z.infer<
  typeof findPricingTypesResultSchema
>;

export const deletePricingTypeInput = z.object({
  id: z.uuid(),
});

export type DeletePricingTypeInput = z.infer<typeof deletePricingTypeInput>;

export const deletePricingTypeResultSchema = z.object({
  id: z.uuid(),
});

export type DeletePricingTypeResult = z.infer<
  typeof deletePricingTypeResultSchema
>;
